export default [
    {
        name: 'Contratações',
        url: '/credenciados/uabs/contratacoes',
        icon: 'fa fa-book',
        badge: {
            variant: 'primary',
            text: 'UABS'
        },
        regras: 'CRED-UABS-CONT-00'
    },
    {
        name: 'Pagamentos',
        url: '/credenciados/uabs/finalizacoes',
        icon: 'fa fa-dollar',
        badge: {
            variant: 'primary',
            text: 'UABS'
        },
        regras: 'CRED-UABS-FIN-00'
    },
    {
        name: 'Aditivos',
        url: '/credenciados/uabs/solicitacoesaditivos',
        icon: 'fa fa-plus-circle',
        badge: {
            variant: 'primary',
            text: 'UABS'
        },
        regras: 'CRED-UABS-ADIT-00'
    },
    {
        name: 'Reaberturas de Entregas',
        url: '/credenciados/uabs/solicitacoesreaberturas',
        icon: 'fa fa-refresh',
        regras: 'CRED-UABS-ENTR-06'
    },
    {
        name: 'Excluir Movimentos',
        url: '/credenciados/admin/excluir-movimentos-em-lote',
        icon: 'fa fa-trash',
        regras: 'CRED-ADMIN-00'
    }
]
